/**
 * Function to check input fields in phone form, then user can interact with form
 * @param {String} nameOfElement - Name of component to get dom elements from id
 * @param {NodeList} nodeList - NodeList of dom elements
 */
export const checkInputPhone = (nameOfElement, nodeList) => {
    const ids = getDomElementsFromId(nameOfElement, nodeList);

    const inputValues = getValuesOfInputFromForm(ids);

    casesOfInputPhone.areaCode(inputValues, ids);
    casesOfInputPhone.characteristics(inputValues, ids);
    casesOfInputPhone.number(ids);
};

const getValuesOfInputFromForm = (ids) => {
    const areaCodeQuantity = ids.area.value.length;
    const characteristicsQuantity = ids.characteristic.value.length;
    const numberQuantity = ids.number.value.length;

    return {
        areaCodeQuantity,
        characteristicsQuantity,
        numberQuantity
    };
};

const getDomElementsFromId = (name, nodeList) => {
    return {
        area: getElementFromid(`${name}AreaCode`, nodeList),
        number: getElementFromid(`${name}Number`, nodeList),
        characteristic: getElementFromid(`${name}Characteristic`, nodeList),
    };
};

const getElementFromid = (id, nodeList = []) => {
    return Array.from(nodeList).find(el => el.id === id);
};

const casesOfInputPhone = {
    areaCode: (inputValues, ids) => {
        const { areaCodeQuantity, characteristicsQuantity } = inputValues;

        if (areaCodeQuantity === 0) {
            lengthOfInput.characteristics(ids, 4);
        }

        if (areaCodeQuantity === 2) {
            lengthOfInput.characteristics(ids, 4);

            if (characteristicsQuantity === 4) {
                ids.number.focus();
            }
        }

        if (areaCodeQuantity === 3) {
            lengthOfInput.characteristics(ids, 3);

            if (characteristicsQuantity === 3) {
                ids.number.focus();
            }
        }

        if (areaCodeQuantity === 4) {
            lengthOfInput.characteristics(ids, 2);
            ids.characteristic.focus();

            if (characteristicsQuantity === 2) {
                ids.number.focus();
            }
        }
    },

    characteristics: (inputValues, ids) => {
        const { characteristicsQuantity } = inputValues;

        if (characteristicsQuantity === 0 || characteristicsQuantity === 2) {
            lengthOfInput.areaCode(ids, 4);
        }

        if (characteristicsQuantity === 3) {
            lengthOfInput.areaCode(ids, 3);
        }

        if (characteristicsQuantity === 4) {
            lengthOfInput.areaCode(ids, 2);
        }
    },

    number: (ids) => {
        lengthOfInput.number(ids, 4);
    }

};

const lengthOfInput = {
    areaCode: (ids, maxLength) => (ids.area.maxLength = maxLength),
    characteristics: (ids, maxLength) => (ids.characteristic.maxLength = maxLength),
    number: (ids, maxLength) => (ids.number.maxLength = maxLength),
};

/**
 * Function to limit the length of input fields in phone form
 * @param {String} nameOfElement - Name of component to get dom elements from id
 * @param {NodeList} nodeList - NodeList of dom elements
 * @param {String} inputName - Name of input to get value from by Default is number input
 * @param {Number} maxLength - Max length of input, by Default is 4
 */

export const limitLenght = (nameOfElement, nodeList, inputName = 'all', maxLength = 4) => {
    const ids = getDomElementsFromId(nameOfElement, nodeList);

    if (inputName === 'area') {
        return lengthOfInput.areaCode(ids, maxLength);
    }
    else if (inputName === 'characteristic') {
        return lengthOfInput.characteristics(ids, maxLength);
    }
    else if (inputName === 'number') {
        return lengthOfInput.number(ids, maxLength);
    }
};
